import { UpdateProps } from "../components/public_site/blocks/custom_blocks/widgets/latestBlock";

export const dummyButton = (
  title: string
): ({
  kind: "link";
  is_link_external: boolean;
  target: "_blank" | "_self";
  url: string;
}) & { title: string } => {
  return {
    is_link_external: false,
    kind: "link",
    target: "_self",
    title: title,
    url: "#"
  };
};

export const dummyUpdates : UpdateProps[] = [
  { 
    title: 'Vijf tips voor een energiezuinige woning', 
    image: null,
    url: '#testURL',
    date: '20-09-2019'
  },
  { 
    title: 'Lorem ipsum dolor sit amet consectetur.', 
    image: null,
    url: '#testURL',
    date: '21-09-2019'
  },
  { 
    title: 'Vijf tips voor een energiezuinige woning', 
    image: null,
    url: '#testURL',
    date: '23-09-2019'
  }
]



// WEBPACK FOOTER //
// ./Client/styleguide/dummyContent.tsx